// extracted by mini-css-extract-plugin
module.exports = {"container":"player_container__2ZA3Y","subContainer":"player_subContainer__3ETST","flexyFix":"player_flexyFix__1ImVG","infoBox":"player_infoBox__1Fj6g"};